import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MessageService } from 'primeng/api';
import { ActivatedRoute, Router } from '@angular/router';
import { account } from 'src/app/shared/models/accountInfo';

@Injectable({
  providedIn: 'root',
})
export class accountService {
  baseUrl: string = environment.cloudUrl;
  modeUrl: string = this.baseUrl + 'password/request/otp';
  constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private router: Router
  ) {}

  send(data: account): Observable<any> {
    const url = this.modeUrl;
    return this.http.post<account>(url, data).pipe(
      map((data) => {
        return data;
      }),
      catchError(this.handleError)
    );
  }
  handleError(error) {
    let errorMessage = '';
    if (
      error.error instanceof ErrorEvent ||
      error.status == 404 ||
      error.status == 401
    ) {
      // client-side error
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // server-side error
      errorMessage = error.statusText;
    }
    return throwError(errorMessage);
  }
}
